import type { PropsWithChildren } from 'react';
import AnchoredPopover from '../../generic/AnchoredPopover';
import Grape from '../grid/Grape';
import * as style from './Popover.module.css';

export interface Props {
    id: string;
    name: string;
    summary: string;
    grapeType: 'green' | 'blue';
    url?: string;
    'aria-label'?: string;
}

export default function GrapePopover({ id, name, summary, grapeType, url, children, ...props }: PropsWithChildren<Props>) {
    return (
        <AnchoredPopover className={style.popover} id={`popover-grape-${id}`} data-modal-name="drue" buttonChildren={children} {...props}>
            <Grape name={name} summary={summary} grapeType={grapeType} />
            {url ? <a href={url}>Vil du lese mer om {name}?</a> : null}
        </AnchoredPopover>
    );
}
